export const api =  "https://tapi.trendreader.co.id/";
export const sessCode = "7r3ndr34d3r71m3";
export const client = "Time International";
export const subTitle = "Media Monitoring Tools";